(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wyze-billing-cycle-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wyze-billing-cycle-toggle')) {
    const PERIODS = ['monthly', 'annual'];
    const CHANGE_EVENT = 'wyze-billing-cycle-toggle:change';
    const SYNC_EVENT = 'wyze-billing-cycle-toggle:sync';
    const OPTION_ACTIVE = 'wyze-billing-cycle-toggle__option--active';
    const SAVE_HIDDEN = 'wyze-billing-cycle-toggle__save--hidden';
    const ARROW_KEYS = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];

    class WyzeBillingCycleToggle extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onSync = this.onSync.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener(SYNC_EVENT, this.onSync);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener(SYNC_EVENT, this.onSync);
      }

      onClick(event) {
        const option = event.target.closest('[data-period]');

        if (!option || !this.contains(option)) return;

        this.apply(option.getAttribute('data-period'), { broadcast: true });

        if (option.focus) option.focus();
      }

      onKeydown(event) {
        if (ARROW_KEYS.indexOf(event.key) === -1) return;

        const option = event.target.closest('[data-period]');

        if (!option || !this.contains(option)) return;

        const options = Array.from(this.querySelectorAll('[data-period]'));

        if (!options.length) return;

        event.preventDefault();

        const index = options.indexOf(option);
        let next = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          next = (index + 1) % options.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          next = (index - 1 + options.length) % options.length;
        } else if (event.key === 'Home') {
          next = 0;
        } else {
          next = options.length - 1;
        }

        const nextOption = options[next];

        this.apply(nextOption.getAttribute('data-period'), { broadcast: true });

        if (nextOption.focus) nextOption.focus();
      }

      onSync(event) {
        if (!event.detail) return;
        if (event.detail.source === this) return;

        this.apply(event.detail.period, { broadcast: false });
      }

      apply(period, opts) {
        const broadcast = opts && opts.broadcast;

        if (PERIODS.indexOf(period) === -1) return;
        if (this.getAttribute('data-current-period') === period) return;

        this.setAttribute('data-current-period', period);
        applyPeriodRoots(period);

        for (const option of this.querySelectorAll('[data-period]')) {
          const isActive = option.getAttribute('data-period') === period;

          option.setAttribute('aria-checked', isActive ? 'true' : 'false');
          option.setAttribute('tabindex', isActive ? '0' : '-1');
          option.classList.toggle(OPTION_ACTIVE, isActive);
        }

        const saveTag = this.querySelector('[data-save]');

        if (saveTag) {
          const hideSave = period !== 'annual';

          saveTag.classList.toggle(SAVE_HIDDEN, hideSave);

          if (hideSave) {
            saveTag.setAttribute('aria-hidden', 'true');
          } else {
            saveTag.removeAttribute('aria-hidden');
          }
        }

        this.dispatchEvent(
          new CustomEvent(CHANGE_EVENT, {
            detail: { period: period },
            bubbles: true
          })
        );

        if (broadcast) {
          document.dispatchEvent(
            new CustomEvent(SYNC_EVENT, {
              detail: { period: period, source: this }
            })
          );
        }
      }
    }

    function applyPeriodRoots(period) {
      if (PERIODS.indexOf(period) === -1) return;

      const roots = document.querySelectorAll('[data-wyze-period-root]');

      for (const root of roots) {
        root.setAttribute('data-current-period', period);
      }
    }

    customElements.define('wyze-billing-cycle-toggle', WyzeBillingCycleToggle);

    if (typeof customElements.upgrade === 'function' && typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        customElements.upgrade(event.target);
      });
    }
  }
  } catch(e) { console.error(e); }
})();

})();
